import { Box, Link } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type Props = {
  isSubscriptionDeactivated?: boolean;
  showLink?: boolean;
};

export const SubscriptionBanner: React.FC<Props> = ({
  isSubscriptionDeactivated = false,
  showLink = false,
}) => {
  const { t } = useTranslation();

  return isSubscriptionDeactivated ? (
    <Box
      backgroundColor="#fffbe6"
      border="1px solid #ffe58f"
      paddingX={"1rem"}
      paddingY={"0.5rem"}
      borderRadius={"0.5rem"}
      marginBottom={"1rem"}
    >
      {t("profile.subscriptionDeactivatedMessage")}
      {showLink && (
        <Link color="purple.500" href="#/client/profile" marginLeft="0.5rem">
          {t("profile.subscriptionActivateNow")}
        </Link>
      )}
    </Box>
  ) : null;
};
